import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function myProfileReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_MYPROFILES_SUCCESS_ACTION:
      return {
        ...state,
        myProfileList: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
}
